import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

const Header: React.FC = () => {
  const { isAuthenticated, loginWithRedirect, logout, user } = useAuth0();
  const [userRole, setUserRole] = useState<string>('general');

  // Load user role for admin features
  useEffect(() => {
    if (!isAuthenticated || !user?.email) return;

    // Check cache first
    const cachedRole = localStorage.getItem(`userRole_${user.email}`);
    if (cachedRole) {
      setUserRole(cachedRole);
    }

    // Load role in background
    const loadRole = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/user-profile`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            sub: user.sub,
            email: user.email,
            name: user.name
          })
        });

        if (response.ok) {
          const userProfile = await response.json();
          setUserRole(userProfile.role);
          localStorage.setItem(`userRole_${user.email}`, userProfile.role);
        }
      } catch (error) {
        console.warn('Failed to load user role:', error);
      }
    };

    loadRole();
  }, [isAuthenticated, user]);

  return (
    <header className="header">
      <nav className="nav">
        <div>
          <Link to="/" className="nav-link">
            <h1 style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              Storage Tank Platform
            </h1>
          </Link>
        </div>
        
        <div className="nav-links">
          {isAuthenticated && (
            <>
              <Link to="/dashboard" className="nav-link">Dashboard</Link>
              <Link to="/county-map" className="nav-link">Map</Link>
              <Link to="/search" className="nav-link">Search</Link>
              {userRole === 'admin' && (
                <Link to="/tank-ai" className="nav-link">Tank AI</Link>
              )}
            </>
          )}
        </div>
        
        <div>
          {!isAuthenticated ? (
            <button 
              className="btn btn-primary"
              onClick={() => loginWithRedirect()}
            >
              Login
            </button>
          ) : (
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
              <Link 
                to="/settings" 
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  textDecoration: 'none',
                  transition: 'background-color 0.2s ease',
                  fontSize: '1.2rem'
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.2)'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)'}
                title={`Settings for ${user?.name || 'User'}`}
              >
                <span style={{ color: 'white' }}>👤</span>
              </Link>
              <button 
                className="btn btn-secondary"
                onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
              >
                Logout
              </button>
            </div>
          )}
        </div>
      </nav>
    </header>
  );
};

export default Header;